
export default {
  props: {
    companyName: {
      type: String,
      required: true,
    },
    bgImage: {
      type: String,
      default: '',
    },
  },
  computed: {
    image() {
      return this.bgImage || this.$static('/img/seller-standard.jpeg')
    },
  },
}
